// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__aUhI3","link":"NavBar_link__pYX+7","active":"NavBar_active__sAUpE"};